(() => {
  'use strict';

  function prefill(root = document) {
    const params = new URLSearchParams(window.location.search);
    const item = params.get('service_item');
    const key = params.get('service_package');
    if (!item && !['cleaning', 'setup', 'remote'].includes(key)) return;
    root.querySelectorAll('[data-pg-service-request]').forEach((field) => {
      // Retain any customer edits, restored draft, or server-side validation value.
      if (field.value.trim()) return;
      let message = '';
      if (item && field.form) {
        const option = Array.from(field.form.querySelectorAll('[data-pg-service-message]'))
          .find((entry) => entry.dataset.pgServiceKey === item);
        message = option ? option.dataset.pgServiceMessage : '';
      } else if (!item) {
        message = field.dataset[key + 'Message'];
      }
      if (message) field.value = message;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prefill(), { once: true });
  } else {
    prefill();
  }
  document.addEventListener('shopify:section:load', (event) => prefill(event.target));
})();
